import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { IconLinkArrow } from '@fabric-app/icons/svg';
import { Button } from '@fabric-app/ui/components/Button';
import { hasHover } from '@fabric-app/ui/constants/styled-utils';

const FloatingExternalLinkButton = styled(Button).attrs((p) => {
  return {
    size: "lg",
    variant: "bg-primary-reverse",
    shape: "square",
    ...p,
    children: /* @__PURE__ */ jsx(IconLinkArrow, {
      style: {
        width: ".875rem",
        height: ".875rem"
      }
    })
  };
}).withConfig({
  displayName: "FloatingExternalLinkButton",
  componentId: "sc-82cf817e-0"
})([
  `border-radius:1rem;position:absolute;right:-0.75rem;top:-0.75rem;z-index:20;display:none;`,
  `{display:flex;&:hover{scale:1.05;}}`
], hasHover);

export { FloatingExternalLinkButton };
//# sourceMappingURL=FloatingExternalLinkButton.js.map
